[
  {
    "question": "What do I get?",
    "answer": "The whole catalogue: every pack on Narcis, nine photographs of you in one setting each, and single photos too, all made with your face. Your model, created from your photos, is how your face gets into it."
  },
  {
    "question": "How much does it cost?",
    "answer": "{PRICE_LINE} You pay once, when you create your model, before any photo of you is made. Every pack on Narcis is then made with your face. {GUARANTEE}"
  },
  {
    "question": "Is there a subscription?",
    "answer": "No. You pay {PRICE_LABEL} once, when you create your model. Nothing renews."
  },
  {
    "question": "Do I have to write a prompt?",
    "answer": "No. {NOTHING_TO_WRITE_LINE}"
  },
  {
    "question": "Can I change a photo I got?",
    "answer": "Yes. {EDIT_LINE}"
  },
  {
    "question": "How long does it take?",
    "answer": "Your photos are ready in a few hours — usually about three, sometimes up to eight. You can close the page: we email you when they are ready."
  },
  {
    "question": "What photos should I add?",
    "answer": "Six to twenty clear photos of yourself, from different days and in different light. Your face easy to see, no heavy filters and no sunglasses. We check each photo when you add it."
  },
  {
    "question": "What happens to my photos?",
    "answer": "Your photos are used to create your model and nothing else — never anyone else's model. They are processed on our servers in the EU, not sent to a big-tech API. Delete your model from your account and your photos are deleted with it."
  },
  {
    "question": "Can I get a refund?",
    "answer": "Yes. {GUARANTEE} {REFUND_HOW}"
  },
  {
    "question": "Can I make a model of someone else?",
    "answer": "Yes, if they agree to it. A model of another person is a new purchase, at the same price."
  },
  {
    "question": "What if I want a new model from new photos?",
    "answer": "A model is made once and does not change. New photos make a new model: a new purchase, at the same price."
  },
  {
    "question": "Do I need an account?",
    "answer": "To create your model, yes: you sign in when you pay, and we email you when your photos are ready. You can look at every pack without one, and the face swap needs none."
  },
  {
    "question": "Can I use these AI photos commercially?",
    "answer": "Yes. Your photos are yours to use anywhere, personal or commercial, with no need to name Narcis and no permission to ask."
  },
  {
    "question": "How is narcis different from HeadshotPro, Aragon, or Photo AI?",
    "answer": "HeadshotPro and Aragon create a model for one shoot: you pay, you get one set of photos, and new photos mean a new paid run. Photo AI is a monthly subscription. Narcis is one payment for your model, and every pack on Narcis, 35,000 art-directed photographs, is then made with your face."
  },
  {
    "question": "Why don't these look AI-generated?",
    "answer": "Because every pack is built against real photos and paintings and tested on real faces before it goes live. The result reads as a photograph of you in one setting — not the shiny, same-looking AI style of generic tools."
  },
  {
    "question": "Is the face swap really free?",
    "answer": "Yes. Five swaps with no account and no card."
  },
  {
    "question": "Can I print or frame the art portraits?",
    "answer": "Yes. The Sargent, Vermeer, and Caillebotte packs are photographs posed in those painters' light, dress, and framing — not copies of paintings — and they read well printed on matte paper."
  }
]
